import React from "react";
import { Typography } from "@material-ui/core";
import { IDocumentoResponse } from "models/response/documento-response";
import { buildDownloadFileName } from "utils/download-file";
import { DocumentButton, DocumentDate, DocumentInfo, DocumentNotice, DocumentRow, DocumentTitle } from "./document-list.styles";

interface DocumentListProps {
  documents?: IDocumentoResponse[];
}

const buildDownloadHref = (doc: IDocumentoResponse): string => {
  const fileName = buildDownloadFileName(doc.descricao, doc.documentoUrl);
  const separator = doc.documentoUrl.includes("?") ? "&" : "?";
  return `${doc.documentoUrl}${separator}fileName=${encodeURIComponent(fileName)}`;
};

export function DocumentList({ documents }: DocumentListProps) {
  if (!documents || documents.length === 0) {
    return <Typography variant="body2" color="textSecondary">Nenhum documento anexado.</Typography>;
  }

  return (
    <div>
      {documents.map((doc) => (
        <DocumentRow key={doc.id}>
          <DocumentInfo>
            <DocumentTitle>{doc.descricao}</DocumentTitle>
            <DocumentDate>{new Date(doc.dtaPublicacao).toLocaleDateString('pt-BR')}</DocumentDate>
          </DocumentInfo>
          <DocumentButton href={buildDownloadHref(doc)}>
            Baixar documento
          </DocumentButton>
        </DocumentRow>
      ))}
      <DocumentNotice>
        Os documentos disponibilizados estão em formato PDF. Para visualizá-los após o download, é necessário ter um leitor de PDF instalado em seu dispositivo (como o Adobe Acrobat Reader ou similar).
      </DocumentNotice>
    </div>
  );
}
